// extracted by mini-css-extract-plugin
export default {"checkout-form":"AdyenForm--checkout-form--flj01","checkoutForm":"AdyenForm--checkout-form--flj01"};